<template>
  <f7-page class="page-message-customer-list has-footer" @page:init="pageMounted" @page:reinit="pageMounted">
    <f7-navbar :sliding="false">
      <f7-nav-title sliding>XỬ LÝ {{ title_play_style(region, playStyle) }}</f7-nav-title>
      <f7-nav-right>
        <f7-link href="/khach-hang/tao-moi" icon-ios="f7:person_badge_plus"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block-title>KHÁCH</f7-block-title>
    <template v-if="!_.isEmpty(customers_khach)">
      <f7-list>
        <f7-list-item v-for="(item, idx) in customers_khach" :key="idx" :title="item.fullname" @click.prevent="chooseCustomer(item)">
          <f7-link slot="after" z-index="999" icon-f7="ellipsis_vertical" @click.stop="item_selected = item" popover-open=".popover-menu-customer"></f7-link>
        </f7-list-item>
      </f7-list>
    </template>
    <f7-block strong v-else class="text-align-center">
      Chưa có dữ liệu
    </f7-block>
    <f7-block-title>CHỦ</f7-block-title>
    <template v-if="!_.isEmpty(customers_chu)">
      <f7-list>
        <f7-list-item v-for="(item, idx) in customers_chu" :key="idx" :title="item.fullname" @click.prevent="chooseCustomer(item)">
          <f7-link slot="after" z-index="999" icon-f7="ellipsis_vertical" @click.stop="item_selected = item" popover-open=".popover-menu-customer"></f7-link>
        </f7-list-item>
      </f7-list>
    </template>
    <f7-block strong v-else class="text-align-center">
      Chưa có dữ liệu
    </f7-block>
    <f7-popover class="popover-menu-customer">
      <f7-list>
        <f7-list-item link popover-close @click="goToEdit(item_selected)" title="Sửa">
          <f7-icon slot="media" f7="pencil"></f7-icon>
        </f7-list-item>
        <f7-list-item link popover-close @click="copyCustomer(item_selected)" title="Copy">
          <f7-icon slot="media" f7="doc_on_doc"></f7-icon>
        </f7-list-item>
        <f7-list-item link popover-close @click="removeCustomer(item_selected)" title="Xóa">
          <f7-icon slot="media" f7="trash"></f7-icon>
        </f7-list-item>
      </f7-list>
    </f7-popover>
    <Footer/>
  </f7-page>
</template>
<script>
import Footer from "@/components/Footer";
import {mapState} from 'vuex';

export default {
  props     :{
    region   :String,
    playStyle:String,
  },
  components:{
    Footer
  },
  computed  :{
    ...mapState(['customers']),
    customers_khach(){
      return this._.filter(this.customers, {type:1})
    },
    customers_chu(){
      return this._.filter(this.customers, {type:2})
    }
  },
  data(){
    return {
      regions:{
        mn:'Miền Nam',
        mb:'Miền Bắc',
        mt:'Miền Trung'
      },
      item_selected:{}
    }
  },
  methods:{
    chooseCustomer(customer){
      this.$store.state.selected_customer = customer;
      this.$f7router.navigate(`/xu-ly/${this.region}/${this.playStyle}/khach-hang/${customer.id}`);
    },
    goToEdit(customer){
      this.$f7router.navigate(`/khach-hang/chi-tiet/${customer.id}`, {
        props:{
          customer:customer
        }
      });
    },
    copyCustomer(customer){
      this.$f7router.navigate(`/khach-hang/tao-moi`, {
        props:{
          customer_source:customer
        }
      });
    },
    removeCustomer(customer){
      const self = this;
      this.$f7.dialog.confirm('Bạn có chắc chắn muốn xóa Khách hàng : ' + customer.fullname, 'THÔNG BÁO!', () => {
        self.$f7.dialog.preloader();
        self.$store.dispatch('removeCustomer', {
          id:customer.id
        }).then(() => {
          return self.$store.dispatch('getCustomers', {
            page :1,
            limit:1000
          });
        }).then(() => {
          self.$f7.dialog.close();
        }).catch((err) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert(err, 'LỖI!');
        });
      });
    },
    pageMounted(){

    }
  }
};
</script>
